export const setAllSelected = ({ select, section }) => (state, actions) => {
  state[section].items.forEach(item =>
    Promise.resolve({ section, select, value: item.id }).then(
      actions.setSelected,
    ),
  );
};
